import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Menu from "./components/Menu";
import Event from "./components/Event";
import Loyalty from "./components/Loyalty";
import Gallery from "./components/Gallery";
import WhyUs from "./components/WhyUs";
import Testimonials from "./components/Testimonials";
import FindUs from "./components/FindUs";
import Footer from "./components/Footer";

export default function HomePage() {
  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <Menu />
      <Event />
      <Loyalty />
      <Gallery />
      <WhyUs />
      <Testimonials />
      <FindUs />
      <Footer />
    </>
  );
}